<div gs1Modal
     width="700"
     title="Nouvelle fonctionnalité : lien « En savoir plus » sur la page des informations nutritionnelles"
     [customHtml]="htmlModal"
     confirm="Accéder à mes produits"
     [confirmDisabled]="false"
     (closed)="validateDisclaimer($event)"
     [closeButton]="false"
     [disableClose]="true"
     #directiveVCSRef="gs1Modal">
</div>
